import { useCallback, useEffect, useState } from 'react';
import type { SellerConnection } from '../../api/amazonconnect';
import type { DatePreset } from '../types';
import { loadRestBlocks, type RestBlocksModel } from './loadRestBlocks';

export function useRestBlocks(opts: {
  refreshToken?: number;
  connection: SellerConnection | null;
  datePreset?: DatePreset;
}) {
  const { refreshToken = 0, connection, datePreset } = opts;
  const [model, setModel] = useState<RestBlocksModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setModel(await loadRestBlocks({ connection, datePreset }));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load remaining blocks');
      setModel(null);
    } finally {
      setLoading(false);
    }
  }, [connection, datePreset]);

  useEffect(() => {
    void reload();
  }, [reload, refreshToken]);

  return { model, loading, error, reload };
}
